// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import ConditionalSubform from "../../components/ConditionalSubform";
import EditableField from "../../components/EditableField";
import * as formConditions from "../../utils/formConditions";
import * as formatters from "../../utils/formatters";

import {
  AMOUNT,
  FINANCING_OWN_FOUNDS,
  FINANCING_DEMAND,
  FINANCING_SUPPORT,
  FINANCING_OWN_IDEA
} from "./formFields";

import { type FinancingSectionProps } from "../../types/details";
import { mapSupport } from "./mappers";

const FinancingFounder = ({ initialValues, site }: FinancingSectionProps) => {
  return (
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: FINANCING_SUPPORT,
            caption: () => "Unterstützung durch einen Experten"
          }}
          displayValue={mapSupport(site === "customer")}
        />
        <ConditionalSubform
          condition={formConditions.fieldHasValue(FINANCING_SUPPORT, false)}
          renderOnSatisfy={() => (
            <>
              <EditableField
                fieldControlProps={{
                  name: FINANCING_OWN_IDEA,
                  caption: () => "Strukturierung des Finanzierungsvorhabens"
                }}
              />
              <div />
            </>
          )}
        />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: AMOUNT,
            caption: () => "Investitionskosten"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: FINANCING_OWN_FOUNDS,
            caption: () => "Eigenmittel"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: FINANCING_DEMAND,
            caption: () => "Finanzierungsbedarf"
          }}
          displayValue={formatters.formatCurrency}
        />
      </FormRow>
    </EditableForm>
  );
};

export default FinancingFounder;
